import { createContext } from 'react';

export const WebComponentsContext = createContext({
    language: 'en'
});
